import gql from 'graphql-tag';
export const SOCIAL_USER_SEARCH = gql `
  query SocialUserSearch($query: String!) {
    viewer {
      socialUserSearch(query: $query) {
        collection {
          userId
          user {
            displayName
            profileImage(size: SQUARE_64) {
              url
            }
            occupations {
              headline
            }
          }
          isMentionable
        }
      }
    }
  }
`;
//# sourceMappingURL=social-user-search.gql.js.map